// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H7.07713C9.24103 2 11 3.75897 11 5.92277V11H5.92287C3.75893 11 2 9.24099 2 7.07705V2ZM13 5.92277C13 3.75897 14.759 2 16.9229 2H22V7.07705C22 9.24099 20.2411 11 18.0771 11H13V5.92277ZM2 16.9229C2 14.759 3.75893 13 5.92287 13H11V18.0772C11 20.241 9.24103 22 7.07713 22H2V16.9229ZM13 13H18.0771C20.2411 13 22 14.759 22 16.9229V22H16.9229C14.759 22 13 20.241 13 18.0772V13Z"}}]};

const System3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-3-filled',
    ref,
    icon: element,
  },
));

System3FilledIcon.displayName = 'System3FilledIcon';

export default System3FilledIcon;
